module.exports = __webpack_public_path__ + "img/fintex_log.7fec6bf4.svg";